<template>
  <div class="row">
    <div class="col-lg-12">
      <el-alert :closable="false" class="mb-3 col-12" title="💡 Info" type="success">
        <p><b>Agent Access Chat</b> setting is allows admins to configure chat access for agent based on multiple filters (bot, all, my group, mine). Agents can be granted access to several filter combinations at once </p>
        <p><b>Checker Maker</b> setting is allows admins to configure broadcast access for schedule notification is limit for users who can create a broadcast and needs approval from checker who choosen </p>
      </el-alert>
      <el-card shadow="never" v-if="isCanChange()">
        <span class="font-weight-bold">Agent Access</span>
        <el-form>
          <el-form-item>
            <el-checkbox v-model="agent.bot">Bot</el-checkbox>
            <el-checkbox v-model="agent.my_group">My Group</el-checkbox>
            <el-checkbox disabled v-model="agent.mine">Mine</el-checkbox>
            <el-checkbox v-model="agent.all">All</el-checkbox>
          </el-form-item>
        </el-form>
        <div align="left">
          <el-button :disabled="![agent.mine].includes(true) ? true : false" @click="updateAccessChat" :loading="loading.other" size="small"
            class="btn-primary" align="right">Update</el-button>
        </div>
      </el-card>
      <el-card class="mt-3" shadow="never" v-if="isCanChange()">
        <el-form>
          <el-form-item width="100px">
            <span class="font-weight-bold mr-2">Activate Maker/Checker</span>
            <el-switch v-model="maker_checker.status" />
            <div v-if="maker_checker.status">
              <div>
                <div class="mt-3">
                  <p class="mb-2">Maker : </p>
                  <el-select v-model="maker_checker.maker" remote :remote-method="loadUsers" filterable multiple placeholder="Select maker" class="w-100">
                    <el-option
                      v-for="(item) in usersList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="mt-3">
                  <p class="mb-2">Checker : </p>
                  <el-select v-model="maker_checker.checker" remote :remote-method="loadUsers" filterable multiple placeholder="Select checker" class="w-100">
                    <el-option
                      v-for="(item) in usersList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="w-100 d-flex mt-4">
              <el-button @click="saveMakerChecker" size="small" class="btn-primary" align="right">Update</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import { upperFirst, isEmpty } from 'lodash';
import popupErrorMessages from '../../../library/popup-error-messages';
import customFeaturesApi from '../../../api/customFeatures';
import usersAPI from '../../../api/users';

export default {
  name: 'Other',
  props: {
    workspace_id: {
      type: String,
    },
  },
  data() {
    return {
      loading: {
        setting: true,
        update_bot: false,
        update_work_hour: false,
        auto_reminder: false,
        custom_contact: false,
      },
      loaderStack: 0,
      loader: null,
      agent: {
        bot: true,
        my_group: true,
        mine: true,
        all: true,
      },
      maker_checker: {
        status: false,
        maker: [],
        checker: [],
      },
      usersList: [],
    };
  },
  methods: {
    isCanChange() {
      let result = false;
      const { is_pic } = this.$store.state.auth.userProfile;
      if (is_pic === true) {
        result = true;
      }
      return result;
    },
    upperCaseFirst(string) {
      return upperFirst(string);
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async loadData() {
      this.$parent.loading.setting = true;
      const response = await customFeaturesApi.getCustomFeature(this.workspace_id);
      await this.loadUsers();
      this.hideLoader();
      this.$parent.loading.setting = false;
      await popupErrorMessages(response);
      const feature = response.data;
      console.log(feature);
      if (!isEmpty(feature.agent)) {
        this.agent = {
          bot: feature.agent.bot,
          my_group: feature.agent.my_group,
          mine: feature.agent.mine,
          all: feature.agent.all,
        };
      }
      if (!isEmpty(feature.maker_checker)) {
        this.maker_checker = {
          status: feature.maker_checker.status,
          maker: feature.maker_checker.maker,
          checker: feature.maker_checker.checker,
        };
      }
    },
    async loadUsers(val = '') {
      const response = await usersAPI.getList(1, val);
      const users = response.data.rows;
      if (users) {
        this.usersList = users.map((user) => ({
          id: user.id,
          name: user.name,
        }));
      }
    },
    async updateAccessChat() {
      this.$parent.loading.other = true;
      const response = await customFeaturesApi.updateAgentCustomFeature(
        this.workspace_id,
        {
          bot: this.agent.bot,
          my_group: this.agent.my_group,
          mine: this.agent.mine,
          all: this.agent.all,
        },
      );
      this.hideLoader();
      this.$parent.loading.other = false;
      await popupErrorMessages(response);
      this.$message({
        type: 'success',
        message: this.$t('settings.success.edit'),
      });
      this.loadWorkHour();
    },
    selectMaker(user_id) {
      this.maker_checker.maker.push(user_id);
    },
    selectChecker(user_id) {
      this.maker_checker.checker.push(user_id);
    },
    async saveMakerChecker() {
      try {
        this.$parent.loading.other = true;
        const response = await customFeaturesApi.updateMakerChecker(
          this.workspace_id,
          {
            status: this.maker_checker.status,
            maker: this.maker_checker.maker,
            checker: this.maker_checker.checker,
          },
        );
        this.hideLoader();
        this.$parent.loading.other = false;
        await popupErrorMessages(response);
        this.$message({
          type: 'success',
          message: this.$t('settings.success.edit'),
        });
      } catch (err) {
        console.log('error :', err);
      }
    },
  },
};
</script>
<style>
.el-switch__label.is-active {
  color: #10b759 !important;
}
.el-date-editor .el-range-separator {
  width: 15%;
}
.el-switch__label {
  color: #BDC3C7;
}
</style>
